import script from "./base-file.vue?vue&type=script&setup=true&lang=ts"
export * from "./base-file.vue?vue&type=script&setup=true&lang=ts"

import "./base-file.vue?vue&type=style&index=0&id=57af1a1e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57af1a1e"]])

export default __exports__